import { apiHelper } from "../../../utils/apiHelper/apiHelper";
import { config } from "../../../config/config";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { helperFunction } from "../../../utils/helperFunctions";

export const getProduct = createAsyncThunk(
    'product/getProduct',
     async (payload, { rejectWithValue }) => {
      try {
        console.log(payload, " ================================>>>>>>>>>> product ")
        const response = await apiHelper("get",`/api/public/product/get-product`);
        console.log(response, " ================================>>>>>>>>>> product ")

        return response.data;
      } catch (err) {
        return rejectWithValue(err.response.data);
      }
    }
  );
